import { ApplicationInsights } from '@microsoft/applicationinsights-web'
// The router measures the performance of the application by tracking page views and route changes: router/index.ts afterEach
// Application-insights: , crv-sis-proxy-tst-we-appi, crv-sis-proxy-acc-we-appi or crv-sis-proxy-prd-we-appi

const connectionStrings = {
  tst: 'InstrumentationKey=f41d1233-b1f6-414c-92ee-7bb9bf75dffe;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=4d0fdb9d-7508-443a-a24c-b3fa4d8f0b71',
  acc: 'InstrumentationKey=599f53d7-a19e-4392-ba5e-deee78737bc8;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=2b8a5a25-0ac7-4917-b9d3-be0f93c8f2f0',
  prd: 'InstrumentationKey=89b7e11a-5a39-41f0-8742-a31f0b6ba5be;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=021f9961-addf-42fe-9bf8-620b20c8a621'
}

const getConnectionString = () => {
  if (process.env.VUE_APP_SEARCH_API_ENDPOINT.includes("tst-")) {
    console.warn('connectionString uses TST azure insights:', connectionStrings.tst)
    return connectionStrings.tst
  } else if (process.env.VUE_APP_SEARCH_API_ENDPOINT.includes("acc-")) {
    console.warn('connectionString uses ACC azure insights:', connectionStrings.acc)
    return connectionStrings.acc
  } else {
    return connectionStrings.prd
  }
}

const connectionString = getConnectionString()


const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true,
    samplingPercentage: 20,
    // With 20% sampling, Application Insights randomly selects 1 in every 5 items to send.
    // AI automatically scales your dashboards to reflect the actual number of users (it extrapolates). 
    // So even with 20% sampling, your "users over time" chart will still estimate 1,000 users — not 200.
    autoTrackPageVisitTime: false, // Reduces the Azure Insights costs
    disableFetchTracking: false, // If we don't need to track all fetch calls, we can enable this to reduce costs
    disableAjaxTracking: false, // If we don't need to track all XHR calls, we can enable this to reduce costs
  },
});

appInsights.loadAppInsights()

export default appInsights





